import moment from 'moment-timezone';

export class AgeValueConverter
{
    toView(date)
    {
        return Math.floor(moment(new Date()).diff(moment(date),'years',true));
    }
}
